import React from "react";

const FilterIcon = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H48C52.4183 0 56 3.58172 56 8V48C56 52.4183 52.4183 56 48 56H8C3.58172 56 0 52.4183 0 48V8Z"
        fill="#F9F9F9"
      />
      <mask
        id="mask0_303_431"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="12"
        y="12"
        width="32"
        height="32"
      >
        <rect x="12" y="12" width="32" height="32" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_303_431)">
        <path
          d="M26.6655 38.6666C26.2877 38.6666 25.971 38.5388 25.7155 38.2833C25.4599 38.0277 25.3321 37.711 25.3321 37.3333V29.3333L17.5988 19.4666C17.2655 19.0221 17.2155 18.5555 17.4488 18.0666C17.6821 17.5777 18.0877 17.3333 18.6655 17.3333H37.3321C37.9099 17.3333 38.3155 17.5777 38.5488 18.0666C38.7821 18.5555 38.7321 19.0221 38.3988 19.4666L30.6655 29.3333V37.3333C30.6655 37.711 30.5377 38.0277 30.2821 38.2833C30.0266 38.5388 29.7099 38.6666 29.3321 38.6666H26.6655Z"
          fill="#2B2B2B"
        />
      </g>
    </svg>
  );
};

export default FilterIcon;
